module.exports = __webpack_public_path__ + "static/media/TRIPLANAR ULTIMATE 12 TONEARM.29c64498.png";